export enum FilterOperator {
  IN = 'in',
  CONTAINS = 'contains',
  GTE = 'gte',
  LTE = 'lte',
}

export interface FilterPredicate<T, O extends FilterOperator> {
  operator: O
  value: T[]
}

export type FilterPredicates<T, O extends FilterOperator> = FilterPredicate<T, O>[]
